// Token storage in localStorage. Simple, not XSS-hardened (v1 scope).
// Keys are namespaced "aste_*" to avoid clashing with other apps on localhost.

const ACCESS_KEY = 'aste_access_token'
const REFRESH_KEY = 'aste_refresh_token'

export function getAccessToken(): string | null {
  return localStorage.getItem(ACCESS_KEY)
}

export function getRefreshToken(): string | null {
  return localStorage.getItem(REFRESH_KEY)
}

export function setTokens(access: string, refresh: string): void {
  localStorage.setItem(ACCESS_KEY, access)
  localStorage.setItem(REFRESH_KEY, refresh)
}

export function clearTokens(): void {
  localStorage.removeItem(ACCESS_KEY)
  localStorage.removeItem(REFRESH_KEY)
}

export function hasTokens(): boolean {
  return Boolean(getAccessToken() && getRefreshToken())
}
